import { API } from 'aws-amplify'

import { ITank } from 'types'

export const getTanks = (country?: string, zone?: string, status?: string, product?: string, type?: string) =>
  API.get('BOC_API', '/getiotdevices', {
    headers: {
      app: 'iotmon',
      country,
      zone,
      status,
      product,
      type,
    },
  })

export const getTankInfo = (tankId: string = '') =>
  API.get('BOC_API', '/getiotdevices', {
    headers: {
      did: tankId.toLowerCase(),
      app: 'iotmon',
    },
  })

export const getTankReadings = (tankId: string, from: number, to: number) =>
  API.get('BOC_API', `/getiotreadings/${(tankId || '').toLowerCase()}`, {
    headers: {
      from: from,
      to: to,
      app: 'iotmon',
    },
  })

export const registerTank = (did: string, shipTo: string, equipment: string, preview: boolean = false) => {
  const body: any = {
    did: (did || '').toLowerCase(),
    preview,
  }
  if (shipTo) {
    body.sh = (shipTo || '').toLowerCase()
  } else {
    body.equipment = equipment
  }
  return API.post('BOC_API', '/registeriotdevice', { body })
}

export const updateTankInfo = (did: string, device: ITank) =>
  API.post('BOC_API', '/updateiotdevice', {
    body: {
      did: (did || '').toLowerCase(),
      device,
    },
  })

export const triggerEDI = (tankId: string = '') =>
  API.post('BOC_API', '/triggerorder', {
    body: { tid: tankId.toLowerCase() },
  })

  export const getMaterialCodes = () => 
    API.get('BOC_API', '/getmaterialcodes', {
      headers: {
        app: 'iotmon'
      }
    })

    
  export const getGeoFencingZones = () => 
  API.get('BOC_API', '/getgeofencingzones', {
    headers: {
      app: 'iotmon'
    }
  })
